import {useState} from "react";
import {ObjectSchema} from "yup";
import {CommonUtils} from "../CommonUtils";
import scrollToClassElement = CommonUtils.scrollToClassElement;

export default function useVivoValidation(validationSchema : ObjectSchema<any>, objectToValidate? : any) {
    const schema = validationSchema; 
    const [formErrors, setFormErrors] = useState<any>({});
    const o = objectToValidate;

    function scrollToFirstInvalid(container: HTMLElement = document.body, topOffset: number = 100): void {
        scrollToClassElement('.k-invalid', container, topOffset);
    }

    function validateForm<T>(objectToValidate? : T) : Promise<T>{
        const v = objectToValidate ?? o;
        return schema.validate(v, {abortEarly: false})
            .then(validData => {
                // resetting errors
                setFormErrors(undefined);
                // Proceed with submission
                console.log('Valid data:', validData);
                return validData;
            })
            .catch(err => {
                // Handle validation errors
                // Extract errors from Yup validation result
                const fieldErrors:any = {};
                const innerErrors : any[] = err.inner;
                err.inner.forEach((e:any) => {
                    fieldErrors[e.path] = e.message;
                });
                setFormErrors(fieldErrors);
                console.error('Validation errors:', formErrors);
                throw innerErrors.map((x: any) => x.message);
            });
    }
    return{
        formErrors,
        validateForm,
        scrollToFirstInvalid
    }
}